import React from 'react';
import cx from 'classnames';
import { Form as FinalForm, Field } from 'react-final-form';

import { FormDropdown, FormInput } from 'components/common/form/FinalFormV2Elements';
import {
  renderEventDescriptionField,
  renderEventAttireField,
  renderEventToggles,
} from 'components/manage/VirtualEvents/common/FormFields/FormFields';
import { RenderDatePicker } from 'components/common/form';
import { timezonesV2, startTimes } from 'components/common/form/timeValues';

import { ButtonV2 as Button } from '@zola/zola-ui';
import EventTypes from 'components/manage/events/util/EventTypes';
import Suggestions from 'pages/Events/SuggestionModal/SuggestionModal';

// util
import * as Validations from 'components/common/form/commonValidations';

// styles
import css from 'components/manage/VirtualEvents/ZoomEdit/zoomEdit.module.less';
import formStyles from 'components/manage/VirtualEvents/MeetingTimeFormFieldSet/MeetingTimeFormFieldSet.module.less';
import styles from '../EditVirtualEventModal.module.less';
import 'components/manage/VirtualEvents/MeetingTimeFormFieldSet/DatePickerV2StyleOverrides.less';

const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

const EditVirtualEventForm = ({
  handleDelete,
  initialValues,
  onSubmit,
  toggleSuggestions,
  showAttire,
}) => {
  const { virtual_meeting: virtualInfo } = initialValues;
  const setAttire = (args, state, { changeValue }) => {
    const value = args[0];
    changeValue(state, 'attire', () => value);
  };

  const containerClass = cx({ [styles.suggestionsActive]: showAttire });

  return (
    <div className={containerClass}>
      <FinalForm onSubmit={onSubmit} initialValues={initialValues} mutators={{ setAttire }}>
        {formProps => {
          return (
            <React.Fragment>
              <Suggestions
                variant="websiteAttire"
                addSuggestion={val => formProps.form.mutators.setAttire(val)}
                toggleSuggestions={toggleSuggestions}
              />
              <form className={styles.form} onSubmit={formProps.onSubmit}>
                <div className={styles.eventFields}>
                  <FormInput
                    name="name"
                    label="Event Title"
                    placeholder="Our Wedding"
                    maxChars={100}
                    validate={[Validations.REQUIRED, Validations.MAX_LENGTH_100]}
                  />
                  <FormDropdown
                    name="type"
                    options={EventTypes}
                    label="Event Type"
                    validate={[Validations.REQUIRED]}
                    placeholder="Select..."
                  />
                </div>
                <div className={cx(formStyles.timeFields, 'eventForm__timeFields')}>
                  <Field
                    name="date"
                    validate={composeValidators(
                      Validations.REQUIRED,
                      Validations.DATE,
                      Validations.DATE_AFTER_NOW
                    )}
                  >
                    {datePickerProps => (
                      <RenderDatePicker
                        label="Date"
                        className={cx(formStyles.marginRight, 'datePickerV2StyleOverride')}
                        autoComplete="off"
                        datePickerOptions={{ disabledDays: { before: new Date() } }}
                        calendarIcon
                        input={datePickerProps.input}
                        meta={datePickerProps.meta}
                      />
                    )}
                  </Field>
                  <FormDropdown
                    className={formStyles.marginRight}
                    name="start_at"
                    label="Start Time"
                    validate={[Validations.REQUIRED]}
                    options={startTimes}
                    // value from date to '3:32 pm'
                  />
                  <FormDropdown
                    name="timezone"
                    options={timezonesV2}
                    label="Time Zone"
                    validate={[Validations.REQUIRED]}
                  />
                </div>
                <div className={css.fieldMarginBottom}>{renderEventDescriptionField()}</div>
                <div className={cx(css.attireFieldGroup, css.fieldMarginBottom)}>
                  {renderEventAttireField(toggleSuggestions)}
                </div>
                <div className={styles.zoomInfo}>
                  <p className={styles.zoomInfoItem}>
                    <span className={styles.zoomBold}>Your Zoom Meeting Link: </span>
                    {virtualInfo.join_url}
                  </p>
                  <p className={styles.zoomInfoItem}>
                    <span className={styles.zoomBold}>Meeting ID: </span>
                    {virtualInfo.meeting_id}
                  </p>
                  {virtualInfo.password && (
                    <React.Fragment>
                      <p className={styles.zoomInfoItem}>
                        <span className={styles.zoomBold}>Password: </span> {virtualInfo.password}
                      </p>
                      <p className={styles.zoomPwText}>
                        Your meeting password is created by Zoom and will be visible to all
                        attending guests. To ensure your privacy, please avoid changing it.
                      </p>
                    </React.Fragment>
                  )}
                </div>
                {renderEventToggles()}
              </form>
              <div className={styles.buttonSet}>
                <Button onClick={handleDelete} variant="tertiary">
                  Delete Event
                </Button>
                <Button onClick={formProps.handleSubmit} className={`${styles.saveBtn}`}>
                  Save Changes
                </Button>
              </div>
            </React.Fragment>
          );
        }}
      </FinalForm>
    </div>
  );
};

export default EditVirtualEventForm;



// WEBPACK FOOTER //
// ./src/components/manage/common/EditVirtualEventModal/EditVirtualEventForm/EditVirtualEventForm.jsx